import { render } from "./BaseTabPanel.vue?vue&type=template&id=a1ab455c&scoped=true"
import script from "./BaseTabPanel.vue?vue&type=script&lang=js"
export * from "./BaseTabPanel.vue?vue&type=script&lang=js"

import "./BaseTabPanel.vue?vue&type=style&index=0&id=a1ab455c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1ab455c"]])

export default __exports__